import { render, staticRenderFns } from "./editAdminComment.vue?vue&type=template&id=16a0a08b&scoped=true"
import script from "./editAdminComment.vue?vue&type=script&lang=js"
export * from "./editAdminComment.vue?vue&type=script&lang=js"
import style0 from "./editAdminComment.vue?vue&type=style&index=0&id=16a0a08b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a0a08b",
  null
  
)

export default component.exports